import React from 'react';

const brands = [
  { name: 'Daikin', logo: '/images/marcas/logo1.webp' },
  { name: 'Mitsubishi Electric', logo: '/images/marcas/logo2.webp' },
  { name: 'Panasonic', logo: '/images/marcas/logo3.webp' },
  { name: 'LG', logo: '/images/marcas/logo4.webp' },
  { name: 'Samsung', logo: '/images/marcas/logo5.webp' },
  { name: 'Toshiba', logo: '/images/marcas/logo6.webp' },
  { name: 'Gree', logo: '/images/marcas/logo7.webp' },
  { name: 'Haier', logo: '/images/marcas/logo8.webp' },
  { name: 'Midea', logo: '/images/marcas/logo9.webp' }
];

/**
 * Banner de marcas com rolagem contínua.
 * A lista é duplicada para que a animação faça loop sem salto visível.
 */
const BrandStrip: React.FC = () => {
  const loop = [...brands, ...brands];

  return (
    <section className="py-12 bg-white border-y border-gray-100" aria-label="Marcas com que trabalhamos">
      <style>{`
        @keyframes alpha-marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .alpha-marquee-track {
          animation: alpha-marquee 32s linear infinite;
          width: max-content;
        }
        .alpha-marquee:hover .alpha-marquee-track {
          animation-play-state: paused;
        }
        /* A faixa deve andar sempre, mesmo com "reduzir movimento" ativo;
           abrandamos apenas o ritmo nesse caso. */
        @media (prefers-reduced-motion: reduce) {
          .alpha-marquee-track { animation-duration: 60s; }
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-sm font-semibold uppercase tracking-wider text-gray-500 mb-2">
          Trabalhamos com as melhores marcas
        </p>
        <p className="text-center text-gray-600 mb-8">
          Instalação, manutenção e peças para os principais fabricantes do mercado
        </p>
      </div>

      <div
        className="alpha-marquee relative overflow-hidden"
        style={{
          maskImage: 'linear-gradient(to right, transparent, black 6%, black 94%, transparent)',
          WebkitMaskImage: 'linear-gradient(to right, transparent, black 6%, black 94%, transparent)'
        }}
      >
        <div className="alpha-marquee-track flex items-center gap-6 sm:gap-10">
          {loop.map((brand, index) => (
            <div
              key={`${brand.name}-${index}`}
              className="shrink-0 h-20 w-40 sm:w-48 flex items-center justify-center rounded-xl bg-white border border-gray-200 shadow-sm px-5"
              aria-hidden={index >= brands.length}
            >
              <img
                src={brand.logo}
                alt={index < brands.length ? `Ar condicionado ${brand.name}` : ''}
                className="max-h-10 max-w-full w-auto object-contain"
                loading="lazy"
                draggable={false}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandStrip;
